<template>
  <div class="selectAdress">
    <top :title="title"></top>
    <div class="setFix"></div>
    <div class="selectAdressMain">
      <div class="amap-page-container">
        <div class="search-box border-bottom-1px">
          <!-- <div class="iptBox">
            <input type="text" placeholder="请输入文字">
          </div> -->
          <el-amap-search-box :search-option="searchOption" :on-search-result="onSearchResult" ref="searchBox">
          </el-amap-search-box>
        </div>
        <div class="amap-demos">
          <el-amap vid="amapDemo"
              :plugin="plugin"
              :center="center"
              :zoom="zoom"
              class="amap-demo"
              :events="events"
              >
            <el-amap-marker v-show="markers.size" v-for="(marker, index) in markers"
              :key="marker.index"
              :position="marker.position"
              :animation="marker.animation"
              :events="marker.events"
              :vid="index"></el-amap-marker>
            <el-amap-info-window v-for="(marker, index) in markers"
              :position="marker.position"
              :content="sendPosition"
              :key="index"></el-amap-info-window>
          </el-amap>
        </div>

        <div class="toolbar">
          <div class="title">当前位置</div>
          <div class="nowAdress">
            <img src="@/assets/imgs/dw.png" />
            <div v-if="loaded">{{sendPosition.length==0?'':sendPosition}}</div>
            <div v-else>请在地图中选择位置</div>
          </div>
          <div class="submit" @click="sendLocation">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Top from '@/component/top/top'
import {Toast} from 'mint-ui'
import { mapMutations } from 'vuex';
export default {
  name: 'selectAdress',
  data() {
    let self = this
    return {
      openid:this.$route.query.openid,
      userpoiId:this.$route.query.userpoiId,
      title:'位置',
      sendPosition: '',
      searchOption: {
        city: '北京',
        citylimit: false
      },
      center: [],
      zoom: 16,
      markers: [],
      plugin: [
        //一些工具插件
        {
          // enableHighAccuracy: true, //是否使用高精度定位，默认:true
          // timeout: 100, //超过10秒后停止定位，默认：无穷大
          // maximumAge: 0, //定位结果缓存0毫秒，默认：0
          // convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          // showButton: true, //显示定位按钮，默认：true
          // buttonPosition: 'LB', //定位按钮停靠位置，默认：'LB'，左下角
          // showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
          // showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
          // panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
          // zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          // extensions: 'all',
          pName: 'Geolocation', //定位
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              // if (!self.center.size) {
              //   console.log(self.center)
              //   return;
              // }
              // o.getCurrentPosition((status, result) => {
              //   console.log(result)
              //   alert(result.position.lng)
              //   if (result && result.position) {
              //     self.sendPosition = result.formattedAddress
              //     self.lng = result.position.lng //设置经度
              //     self.lat = result.position.lat //设置维度
              //     self.center = [self.lng, self.lat] //设置中心坐标 
              //     self.markers[0].position = [self.lng, self.lat]
              //     self.loaded = true //load
              //     var geocoder = new AMap.Geocoder({
              //       radius: 1000,
              //       extensions: 'all'
              //     })
              //     geocoder.getAddress([self.lng, self.lat], function(status, result) {
              //       if (status === 'complete' && result.info === 'OK') {
              //         if (result && result.regeocode) {
              //           self.loaded = true
              //           self.sendPosition = result.regeocode.formattedAddress
              //           self.$nextTick()
              //         }
              //       }
              //     })
              //     self.$nextTick() //页面渲染好后
              //   }
              // })
            //   console.log('3333', o)
            }
          }
        },
        {
          pName: 'ToolBar', //工具栏
          events: {
            init(instance) {
              // console.log('1111', instance)
            }
          }
        },
        {
          pName: 'Scale', //比例尺
          events: {
            init(instance) {
              // console.log(instance)
            }
          }
        }
      ],
      //这是点击地图上的图标实现定位的事件
      events: {
        click(e) {
          let { lng, lat } = e.lnglat
          self.lng = lng
          self.lat = lat
          // self.markers[0] = { position: [self.lng, self.lat] }
          self.markers[0].position = [self.lng, self.lat]

          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: 'all'
          })
          geocoder.getAddress([lng, lat], function(status, result) {
            if (status === 'complete' && result.info === 'OK') {
              if (result && result.regeocode) {
                self.loaded = true
                self.sendPosition = result.regeocode.formattedAddress
                self.$nextTick()
              }
            }
          })
          this.zoom = 16
        }
      },
      lng: 0,
      lat: 0,
      loaded: false
    }
  },
  created() {
    let lon = this.$route.query.lng
    let lat = this.$route.query.lat
    let address = this.$route.query.address
    if(!lon && !lat) {
      lon = localStorage.getItem('lon')
      lat = localStorage.getItem('lat')
    }
    if (lon && lat) {
      this.center = [lon, lat]
    }
    if (address) {
      this.loaded = true
      this.sendPosition = this.$route.query.address 
    }else{
      this.loaded = true
      this.sendPosition = this.getcurrentuserCommunity().address
    }
    this.markers.push( { position: [lon, lat] } )
    this.lng = lon
    this.lat = lat
    
  },
  components:{
    Top
  },
  methods: {
    ...mapMutations(['goBack']),
    //这是搜索框搜索完成后的回调函数
    onSearchResult(pois) {
      let val = this.$refs.searchBox.keyword
      if(val=='') {
        Toast('请输入要搜索的内容')
      }
      let self = this
      let latSum = 0
      let lngSum = 0
      if (pois.length > 0) {
        // pois.forEach(poi => {
        //   let { lng, lat } = poi
        //   lngSum += lng
        //   latSum += lat
        // })
        // let center = {
        //   lng: lngSum / pois.length,
        //   lat: latSum / pois.length
        // }
        let center = {
          lng: pois[0].lng,
          lat: pois[0].lat
        }
        self.lng = pois[0].lng
        self.lat = pois[0].lat
        // self.lng = center.lng
        // self.lat = center.lat
        // 这里通过高德 SDK 完成。
        var geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: 'all'
        })
        geocoder.getAddress([center.lng, center.lat], function(status, result) {
          if (status === 'complete' && result.info === 'OK') {
            if (result && result.regeocode) {
              self.loaded = true
              self.sendPosition = result.regeocode.formattedAddress
              self.$nextTick()
            }
          }
        })

        self.center = [center.lng, center.lat]
        self.markers[0].position = [center.lng, center.lat]
        
      }else{

      }
    },
    //点返回按钮 回到上个页面上
    backSummaryAdd() {
      this.$emit('leaveSelectAdress', '请选择')
    },
    //把经纬度传到父组件
    sendLocation() {
      console.log('获取的精度和纬度', this.lng, this.lat)
      // console.log('获取的地址', this.sendPosition)
      if(this.$route.query.title=='补充信息') {
        //   this.$router.replace(localhost)
        this.$router.push({path:'/errcon',query:{lng:this.lng,lat:this.lat,title:this.$route.query.title,id:this.$route.query.id,ads:this.sendPosition}})
      }else{
        this.$router.push({path:'/errcon',query:{lng:this.lng,lat:this.lat,title:this.$route.query.title,id:this.$route.query.id,ads:this.sendPosition}})
      }
    }
  }
}
</script>
<style lang="less">
@import '~@/assets/less/index.less';
@size: 1/75rem;
.amap-scalecontrol{
  display: none;
}
.el-vue-search-box-container .search-box-wrapper{
    border-top:1px solid #eee;
}
.el-vue-search-box-container .search-tips{
    width: 100%;
    overflow-y:scroll;
}
.el-vue-search-box-container .search-box-wrapper .search-btn{
  background: #25cf8d !important;
  color:#fff !important;
}
.amap-geolocation-con .amap-geo{
  display: none !important;
}
// .amap-info-contentContainer{
//   display: none;
// }
.el-vue-search-box-container{
  z-index:4000 !important;
}
.el-vue-search-box-container .search-box-wrapper input{
  height: 35px !important;
  line-height: 35px !important;
  margin-top:4px;
  background:#eee;
  margin-left:8px;
}
.selectAdress {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffff;
  z-index: 9;
  .selectAdressHeader {
    width: 100%;
    height: 44px;
    background-color: #ff6800;
    position: fixed;
    top: 0;
    z-index: 9;
    overflow: hidden;
    .header-back {
      float: left;
      margin-top: 11px;
      margin-left: 15px;
      width: 22px;
      height: 22px;
      img {
        width: 100%;
        height: auto;
      }
    }
    .header-title {
      position: absolute;
      left: 30%;
      width: 40%;
      height: 44px;
      font-size: 20px;
      color: #ffffff;
      text-align: center;
      line-height: 44px;
      z-index: 1;
    }
  }
  .selectAdressSearch {
    position: relative;
    width: 100%;
    height: 60px;
    margin-top: 44px;
    .selectAdress-search {
      width: 100%;
      height: 60px;
      background-color: #ffffff;
      position: relative;
      img {
        position: absolute;
        width: 40 * @size;
        height: 40 * @size;
        top: 40 * @size;
        left: 6%;
        z-index: 2;
      }
      input {
        box-sizing: border-box;
        position: absolute;
        top: 20 * @size;
        left: 5%;
        width: 90%;
        height: 80 * @size;
        background-color: #eeeeee;
        border-radius: 8 * @size;
        text-indent: 70 * @size;
        color: #c3c3c3;
        font-size: 40 * @size;
      }
    }
  }
  .selectAdressMain {
    position: absolute;
    top: 45px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #cccccc;
    .amap-page-container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99;
      .amap-copyright {
        display: none !important;
      }
      .amap-controls {
        .amap-scalecontrol {
          left: 70px !important;
        }
      }
      .search-box {
        width: 100%;
        height: auto;
        position: relative;
        .iptBox{
          position: absolute;
          top:5px;
          left:15px;
          z-index: 100;
          height: 30px;
          height: 35px;
          line-height: 35px;
          width: 80%;
          input{
            width: 100%;
            height: 100%;
            border:0;
            outline: none;
            background:rgba(0,0,0,0);
          }
        }
        .el-vue-search-box-container {
          width: 100%;
          .search-btn {
            // border: 1px solid red;
            font-size: @ft14;
            margin: 5px 8px;
            height: 35px;
            border-radius: 5px;
          }
        }
      }
      .amap-demos {
        position: absolute;
        top: 50px;
        left: 0;
        right: 0;
        bottom: 150px;
      }
      .toolbar {
        position: absolute;
        bottom: 0;
        left: 0px;
        right: 0px;
        height: 150px;
        background-color: #ffffff;
        .title {
          font-size: @ft16;
          margin-top: 15px;
          padding: 0 20px;
        }
        .nowAdress {
          font-size: 36 * @size;
          margin-top: 8px;
          padding: 0 20px;
          img {
            float: left;
            width: 22px;
            height: auto;
            padding-right: 5px;
          }
          div {
            height: 35px;
            font-size:@ft14;
            width: 90%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
        .submit {
          background-color: #25cf8d;
          color:#fff;
          margin: 15px 20px 0;
          height: 45px;
          text-align: center;
          line-height: 45px;
          border-radius: 5px;
          font-size: 22px;
          font-size:@ft16;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/map/map.vue